/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
/* eslint-disable react/prop-types */
import { InputAdornment, MenuItem } from '@material-ui/core'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import Popover from '@material-ui/core/Popover'
import TextField from '@material-ui/core/TextField'
import Tooltip from '@material-ui/core/Tooltip'
import FilterListIcon from '@material-ui/icons/FilterList'
import SearchIcon from '@material-ui/icons/Search'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'
import React, { useEffect, useState } from 'react'
import { ValidatorForm } from 'react-material-ui-form-validator'
import { useDispatch, useSelector } from 'react-redux'

import BadgeGlobal from '../../components/Badge'
import { fetchServiceCategory } from '../ServiceCategoryActions'
import BaseFilter from '../../../components/hooks/BaseFilter'
import colors from '../../../assets/colors'
import { useQueryParams } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import { Link, useHistory, useLocation } from 'react-router-dom'
import Icon from '@mdi/react'
import { mdiMagnify, mdiMagnifyExpand, mdiNoteEditOutline } from '@mdi/js'
import filterStylesComponents from '../../../assets/filterComponentsStyles'
import ModalServiceCategory from './Modal'

export const Filter = ({ classes }) => {
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { canCreate } = usePermissions()

  const styles = filterStylesComponents()

  const history = useHistory()
  const location = useLocation()
  const filters = useQueryParams(location?.search)

  const [open, setOpen] = useState(false)

  const toggleModal = () => {
    setOpen(!open)
  }

  const onSubmit = (data = filters) => {
    const searchParams = new URLSearchParams(data)
    searchParams.set('page', 1)
    if (open) toggleModal()
    history.push(`${location?.pathname}?${searchParams?.toString()}`)
  }

  const handleChangeStatus = e => {
    e.preventDefault()
    const { name, value } = e.target
    onSubmit({ ...filters, [name]: value })
  }

  const handleSubmit = e => {
    e.preventDefault()

    const formData = e.currentTarget
    const data = new FormData(formData)
    const entries = data.entries()
    const values = Object.fromEntries(entries)

    onSubmit({ ...filters, ...values })
  }

  return (
    <BaseFilter>
      <Grid item xs={12}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item xs={8}>
            <form style={{ width: '100%' }} onSubmit={handleSubmit}>
              <Grid container spacing={2} alignItems="center">
                <Grid item sm={4} xs={12}>
                  <TextField
                    fullWidth
                    label="Filtrar por nome"
                    defaultValue={filters?.name || ''}
                    name="name"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton type="submit">
                            <Icon path={mdiMagnifyExpand} size={1} />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item sm={4} xs={12}>
                  <TextField
                    select
                    label="Filtrar por status"
                    fullWidth
                    name="status"
                    defaultValue={filters?.status || ''}
                    onChange={handleChangeStatus}
                  >
                    <MenuItem value="">Selecione...</MenuItem>
                    <MenuItem value={0}>Inativo</MenuItem>
                    <MenuItem value={1}>Ativo</MenuItem>
                  </TextField>
                </Grid>

                <Grid item sm xs>
                  <IconButton className={styles.btnAdd} type="submit">
                    <Icon path={mdiMagnify} size={1} />
                    Pesquisar
                  </IconButton>
                </Grid>
              </Grid>
            </form>
          </Grid>

          <Grid item xs>
            <Grid container justifyContent="flex-end" alignItems="center">
              {canCreate('categorias-servico', permissionUser) && (
                <IconButton className={styles.btnAdd} onClick={toggleModal}>
                  <Icon
                    path={mdiNoteEditOutline}
                    className={classes.btnIcon}
                    size={1}
                  />
                  Cadastrar
                </IconButton>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <ModalServiceCategory open={open} handleClose={toggleModal} />
    </BaseFilter>
  )
}
